import { render, staticRenderFns } from "./depositList.vue?vue&type=template&id=276e52f3&"
import script from "./depositList.vue?vue&type=script&lang=js&"
export * from "./depositList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports